import AppModal from "components/ui/AppModal";
import AppButton from "components/ui/AppButton";
import AppIcon from "components/ui/AppIcon";
const DeleteDeliveryAreaModal = ({open,area, onClose, onDelete}) => {
    return (
        <AppModal
                open={open}
                onClose={onClose}
                width={550}
                closable={false}
                footer={
                    <div className="mx-auto flex w-full max-w-[760px] items-center justify-center gap-4">
                        <AppButton
                            variant="secondary"
                            size="lg"
                            className=" w-1/2 border border-gray-400 bg-white text-4xl text-gray-500"
                            onClick={onClose}
                        >
                            No, Keep It
                        </AppButton>
                        <AppButton
                            variant="primary"
                            size="lg"
                            className="w-1/2 text-4xl"
                            onClick={onDelete}
                        >
                            Yes, Delete
                        </AppButton>
                    </div>
                }
            >
                <div className="flex flex-col items-center px-8 text-center">
                    <div className="mb-6 h-44 w-44 mt-6">
                        <AppIcon name="trashRed" size={170} className="h-full w-full" />
                    </div>
                    
                    <h1 className="text-24px font-semibold text-gray-900">Delete Area</h1>
                    <p className=" text-3xl text-gray-500 mb-0">
                        Are you sure you want to delete {area}
                    </p>
                </div>
            </AppModal>
    )
}

export default DeleteDeliveryAreaModal;